<template>
    <div class="row alert alert-primary" role="alert" style="word-break:break-all">
        <div class="col-md col-sm-4">
            <div class="form-group">
                <label>班級</label><br />
                <span>{{data.ClassName}}</span>
            </div>
        </div>
        <div class="col-md col-sm-4">
            <div class="form-group">
                <label>姓名</label><br />
                <span>{{data.Name}}</span>
            </div>
        </div>
        <div class="col-md col-sm-4">
            <div class="form-group">
                <label>學號</label><br />
                <span>{{data.StudentNo}}</span>
            </div>
        </div>
        <div class="col-md col-sm-12">
            <div class="form-group">
                <label>手機</label><br />
                <span>{{data.Phone}}</span>
            </div>
        </div>
        <div class="col-md col-sm-12">
            <div class="form-group">
                <label>EMail</label><br />
                <span>{{data.EMail}}</span>
            </div>
        </div>
        <div class="col-md col-sm-12" v-if="vname=='dormitoryDetail'">
            <div class="form-group">
                <label>父親資訊</label><br />
                <span>{{data.FName}}</span><br />
                <span>{{data.FPhone}}</span>
            </div>
        </div>
        <div class="col-md col-sm-12" v-if="vname=='dormitoryDetail'">
            <div class="form-group">
                <label>母親資訊</label><br />
                <span>{{data.MName}}</span><br />
                <span>{{data.MPhone}}</span>
            </div>
        </div>
    </div>
</template>
<script>
    var empty = { ClassName: '', Name: '', StudentNo: '', Phone: '', EMail: '' };

    export default {
        name: 'studata',
        props: ['type', 'id', 'vname'],
        data: function () {
            return {
                data: empty
            }
        },
        created: function () {
            //todo 優化
            if (this.id) {
                this.$http({ method: 'get', url: 'api/ScholarshipDetail/Studata?type=' + this.type + "&id=" + this.id })
                    .then(res => {
                        this.data = res ? res.data : empty;
                        this.data.EMail = this.data.EMail.split("@")[0];
                    })
            }
        },
        watch: {
            id: function (value) {
                if (value) {
                    this.$http({ method: 'get', url: 'api/ScholarshipDetail/Studata?type=' + this.type + "&id=" + value })
                        .then(res => {
                            this.data = res.data ? res.data : empty;
                            this.data.EMail = this.data.EMail.split("@")[0];
                        });
                }
            }
        }
    };
</script>
<style>
</style>
